export default __webpack_public_path__ + "static/media/alarmClockLBIcon.12f141ff.svg";